/**
 * Created by mgoria on 27/04/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocalIdentityProvider = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _IdentityProvider2 = require('./IdentityProvider');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

let LocalIdentityProvider = exports.LocalIdentityProvider = function (_IdentityProvider) {
  _inherits(LocalIdentityProvider, _IdentityProvider);

  /**
   * @param {Array} args
   */
  function LocalIdentityProvider() {
    var _ref;

    _classCallCheck(this, LocalIdentityProvider);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(this, (_ref = LocalIdentityProvider.__proto__ || Object.getPrototypeOf(LocalIdentityProvider)).call.apply(_ref, [this].concat(args)));
  }

  /**
   * @param {String} providerName
   * @param {Object} providers
   * @returns {*}
   */


  _createClass(LocalIdentityProvider, [{
    key: 'getProviderDomain',
    value: function getProviderDomain(providerName, providers) {
      return _get(LocalIdentityProvider.prototype.__proto__ || Object.getPrototypeOf(LocalIdentityProvider.prototype), 'getProviderDomain', this).call(this, providerName, providers) || providerName;
    }
  }]);

  return LocalIdentityProvider;
}(_IdentityProvider2.IdentityProvider);


//////////////////
// WEBPACK FOOTER
// ../~/deep-security/lib.compiled/LocalIdentityProvider.js
// module id = 448
// module chunks = 0